<ng-container *ngIf="bannerVisible$ | async">
  <app-shared-banner class="demo-data-banner app-banner-always-show"
    svgIcon="reports_icon" iconColor=""
    data-html2canvas-ignore #demoDataBanner>
      <h6 banner-header class="typography-h6">
        {{ 'mockData.demoDataBanner.title' | translate: demoBannerParams }}
      </h6>
      <p banner-subheader class="typography-body2">
        {{ descriptionOverride ?? ('mockData.demoDataBanner.description' | translate: demoBannerParams) }}
      </p>

    <div banner-buttons fxLayout="row">
      <button mat-stroked-button color="primary"
        (click)="dismissDemoDataBanner(demoDataBanner)"
        [trackClick]="{page: 'Clicked on Clear Sample  Data', type: 'event'}">
        <mat-icon>delete_outline</mat-icon>
        <div class="banner-button-text">
          {{ 'mockData.demoDataBanner.button' | translate }}
        </div>
      </button>
    </div>
  </app-shared-banner>
</ng-container>
